import {Component} from '@angular/core';


@Component({
    selector: 'out-layout',
    templateUrl: './template.html'
})


export class ComponentOutsideLayout {}